import React, { useState } from 'react';

import LinearProgress from '@material-ui/core/LinearProgress';
import Main from 'components/Layout/Main';
import useUserAgentList from 'api/useAgentList';
import AccessControl from 'components/RBAC/AccessControl';
import permissions from 'permissions';
import Forbidden from 'components/Forbidden';
import UserAgentTableComponent from 'components/UserAgents/List';

function UserAgentsContainer() {

    const [isDeleted,setDeleted]= useState('');
    const { isLoading, userAgents } = useUserAgentList(isDeleted); 

    
    return (
        <Main>
            <AccessControl allowedPermissions={[permissions.userAgents.list]} noAccess={() => <Forbidden/>}>
                {isLoading ? (
                    <LinearProgress color='secondary'/>
                ) : (
                    <UserAgentTableComponent userAgents={userAgents} setDeleted={setDeleted}/>
                )}
            </AccessControl>
        </Main>
    );
}

export default UserAgentsContainer;
